export const itemActions: IRowAction[] = [
  {
    id: 'addToProject',
    title: 'Add to Project',
    iconName: 'IconEdit',
    actionType: 'GENERATORS',
  },
];
